import type React from 'react';

import { ArrowInCircleRightIcon } from '@vlabs/icons';
import { routes } from '@vlabs/shared/navigation/routes';
import { Control } from '@vlabs/uikit';
import type { WithDataTestid } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useHistory, generatePath } from 'react-router-dom';

import { updateFilters } from '@vlabs/pages/events/events/store';

interface EventsFilters {
  top_similar_object_ids: string;
}

interface ShowEventsByFaceIdLinkProps extends WithDataTestid {
  faceId: string;
  setEventsFilters: (filters: EventsFilters) => void;
  className?: string;
}

function ShowEventsByFaceIdLinkComponent({
  faceId,
  setEventsFilters,
  className = undefined,
  'data-testid': dataTestId = 'showEventsByFaceLink',
  ...linkProps
}: ShowEventsByFaceIdLinkProps): React.JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();
  const title = t('monokit:features.show events by face id link.title');
  return (
    <Control.Link
      className={className}
      data-testid={dataTestId}
      icon={<ArrowInCircleRightIcon />}
      kind="primary"
      onClick={() => {
        setEventsFilters({ top_similar_object_ids: faceId });
        history.push(generatePath(routes.events.archive));
      }}
      size="medium"
      title={title}
      to={generatePath(routes.events.archive)}
      {...linkProps}
    >
      {title}
    </Control.Link>
  );
}

const mapDispatchToProps = (dispatch) => ({
  setEventsFilters: (filters: EventsFilters) => dispatch(updateFilters({ filters })),
});

export const ShowEventsByFaceIdLink = connect(
  null,
  mapDispatchToProps,
)(ShowEventsByFaceIdLinkComponent);
